'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WindowMessageObserver = exports.NewWindowObserver = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewWindowObserver = exports.NewWindowObserver = function () {
  function NewWindowObserver() {
    (0, _classCallCheck3.default)(this, NewWindowObserver);

    this.timer = null;
  }

  (0, _createClass3.default)(NewWindowObserver, [{
    key: 'subscribe',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newWindow) {
        var _this = this;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.unsubscribe();
                this.newWindow = newWindow;
                return _context.abrupt('return', new Promise(function (resolve, reject) {
                  _this.timer = window.setInterval(function () {
                    if (_this.newWindow.closed) {
                      reject((0, _util.errorResponseFromMessage)('User cancel the login flow'));
                    }
                  }, 1000);
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function subscribe(_x) {
        return _ref.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }]);
  return NewWindowObserver;
}(); /* global window:false */


var WindowMessageObserver = exports.WindowMessageObserver = function () {
  function WindowMessageObserver(origin) {
    (0, _classCallCheck3.default)(this, WindowMessageObserver);

    this.onMessageReceived = null;
    if (!origin) {
      throw new Error('Origin is required for message observer');
    }
    this.origin = origin.replace(/\/$/, '');
  }

  (0, _createClass3.default)(WindowMessageObserver, [{
    key: 'subscribe',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _this2 = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.unsubscribe();
                return _context2.abrupt('return', new Promise(function (resolve) {
                  _this2.onMessageReceived = function (message) {
                    if (_this2.origin === message.origin) {
                      resolve(message.data);
                      _this2.unsubscribe();
                    }
                  };
                  window.addEventListener('message', _this2.onMessageReceived);
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function subscribe() {
        return _ref2.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this.onMessageReceived) {
        window.removeEventListener('message', this.onMessageReceived);
        this.onMessageReceived = null;
      }
    }
  }]);
  return WindowMessageObserver;
}();